<script lang="ts">
    import {afterNavigate, goto, invalidateAll} from "$app/navigation";
    import {listEmployees} from "$lib/calls/employee";
    import SortableTable from "$lib/components/SortableTable.svelte";
    import Pagination from "$lib/components/Pagination.svelte";
    import {ReadEmployees} from "$lib/utils/tableHeaders/employees";

    import {handleSort, setFilter} from "$lib/utils/pagination/paramPagination";
    import {page} from "$app/stores";
    import PageLayout from "$lib/components/PageLayout.svelte";
    import SearchFilter from "$lib/components/SearchFilter.svelte";
    import {Button, Checkbox, Dropdown, Spinner} from "flowbite-svelte";
    import {ChevronDownOutline} from "flowbite-svelte-icons";
    import {onMount} from "svelte";
    import {employeeStatus} from "$lib/options";
    import type {Employee} from "$lib/types/employee";
    import dayjs from "dayjs";
    import {getUnits} from "$lib/calls/unit";
    import GlobalShortcuts from "$lib/components/GlobalShortcuts.svelte";

    export let data;
    $: pagination = $page.data.paginated_data;

    let loading = true;

    let header = ReadEmployees()

    let additionalFields = {
        createdAt: false,
        employeeNumber: false,
        email: false,
        mobile: false,
        index: true
    }



    const filter = (employmentStatus: string) => {
        setFilter('employmentStatus', employmentStatus, data, '/employees/list');
    }


    let search = $page.url.searchParams.get('search') || '';
    const setSearch = async (search) => {
        await invalidateAll()
        $page.url.searchParams.set(`search`, search)
        await goto('/employees/list?' + $page.url.searchParams.toString())
    }
    const filterOptions = Object.entries(employeeStatus).map((item) => ({label: item[1], value: item[0]}))

    const showHide = (property: string) => {
        header = header.map((item) => {
            if(item.property === property) {
                item.hidden = !additionalFields[property]
            }
            return item;
        })
    }

    onMount(async () => {
        getUnits().then(units => {
            header = [...header, {
                label: 'Unit',
                property: 'unitId',
                sortable: true,
                hidden:false,
                render: (currentEmployee: Employee) => units.find(unit => unit.id === currentEmployee.unitId)?.name || 'Bitte Unit zuordnen',
            }]
        })
        if($page.url.searchParams.get("filter[employmentStatus]") !== 'active'){
            additionalFields.createdAt = true
            showHide('createdAt')
        } else {
            showHide('index')
        }
        console.log({pagination})
    })

</script>
<svelte:head>
    <title>{employeeStatus[data.employmentStatus]}</title>
</svelte:head>
<section>
    <SearchFilter on:enter={ev => setSearch(ev.detail)} on:clear={ev => setSearch('')}>
        <div slot="cta">
            <div class="flex gap-3">
                <Button>Status
                    <ChevronDownOutline class="w-3 h-3 ml-2"/>
                </Button>
                <Dropdown class="w-52 p-3 space-y-3 text-sm">
                    {#each filterOptions as option}
                        <li>
                            <button on:click={() => filter(option.value)}
                                    class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800 whitespace-nowrap"
                                    role="menuitem"
                                    tabindex="-1">
                                {option.label}
                            </button>
                        </li>
                    {/each}
                    <li>
                        <button on:click={() => {$page.url.searchParams.delete(`filter[employmentStatus]`); goto('/employees/list?' + $page.url.searchParams.toString()).then(() => invalidateAll())} }
                                class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800 whitespace-nowrap"
                                role="menuitem"
                                tabindex="-1">
                            Alle
                        </button>
                    </li>
                </Dropdown>
                <Button>Felder
                    <ChevronDownOutline class="w-3 h-3 ml-2"/>
                </Button>
                <Dropdown class="w-52 p-3 space-y-3 text-sm">
                    <li>
                        <Checkbox on:change={() => showHide('employeeNumber')} bind:checked={additionalFields.employeeNumber}>PNR</Checkbox>
                    </li>
                    <li>
                        <Checkbox on:change={() => showHide('index')} bind:checked={additionalFields.index}>Datenampel</Checkbox>
                    </li>
                    <li>
                        <Checkbox on:change={() => showHide('email')} bind:checked={additionalFields.email}>E-Mail</Checkbox>
                    </li>
                    <li>
                        <Checkbox on:change={() => showHide('mobile')} bind:checked={additionalFields.mobile}>Telefon</Checkbox>
                    </li>
                    <li>
                        <Checkbox on:change={() => showHide('createdAt')} bind:checked={additionalFields.createdAt}>Bewerbungsdatum</Checkbox>
                    </li>
                </Dropdown>
            </div>

        </div>
    </SearchFilter>


    <SortableTable rowClick={row => goto('/employee/'+row.uuid)} {header} data={pagination.collection}
                   on:sort={ev => {handleSort(ev,data,'/employees/list')}}/>
    <div class="mt-5">
        <Pagination {pagination}/>
    </div>
    <GlobalShortcuts/>
</section>